<template>
  <div class="PressDetail">
    <div class="title setWidth">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }" class="breadcrumbItem">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/solve' }" class="breadcrumbItem">解决方案</el-breadcrumb-item>
          <el-breadcrumb-item class="breadcrumbItem">当前页面</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="text setWidth">
        {{solveShow.Title}}
    </div>
    <div class="perssTime">
      <el-divider><span>{{solveShow.AddTime|timeFormat()}}</span></el-divider>
        <!-- <p></p>
        <span>{{solveShow.AddTime|timeFormat()}}</span>
        <p></p> -->
    </div>

    <div class="newsItemShow">
        <div class="newsItemShowTop" v-if="solveShow.ArticleType === 1">
            <video  :src="solveShow.Video" controls ></video>
        </div>
        <!-- {{newsItemShow.Content}} -->
        <div v-html="solveShow.Content"></div>
    </div>

  </div>
</template>

<script>
import { getSolveShow } from '@/api/solve'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      solveShow: {} // 解决方案详情
    }
  },
  filters: {
    timeFormat
  },
  mounted () {
    this.getSolveShow({ id: this.$route.params.id })
  },
  methods: {
    backCenter () {
      this.$router.back()
    },
    // 获取解决方案详情
    async getSolveShow (data) {
      const res = await getSolveShow(data)
      const base = request.defaults.baseURL
      const oldBase = '/Upload/Image/'
      if (res.Msg === '获取成功') {
        this.solveShow = res.Data
        this.solveShow.Video = request.defaults.baseURL + this.solveShow.Video
        this.solveShow.Content = this.solveShow.Content.replace(/\/Upload\/Image\//g, base + oldBase)
        // if (this.newsItemShow.Content.indexOf(oldBase) !== -1) {
        //   this.newsItemShow.Content = this.newsItemShow.Content.replace(oldBase, base + oldBase)
        // }
      }
    }
  }

}
</script>

<style  lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.PressDetail{
    // display: flex;
    // justify-content: center;
    // flex-wrap: wrap;
    background: #FFFFFF;
    .setWidth{
        width: 100%;
    }
    // 中间图片
    .newsItemImg{
        width: 1200px*$sun;
        height: 416px*$sun;
    }
    .text{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 50px*$sun 0 40px*$sun 0 ;
        height: 67px*$sun;
        font-size: 34px*$sun;
        font-weight: 500;
        color: #333333;
        // margin: auto;
        text-align: center;
    }
    .perssTimee{
        padding-bottom: 50px*$sun;
    }
    .perssTime{
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: center;
        // align-items: center;
        width: 1200px*$sun;
        margin: 50px*$sun auto;
        p{
            width: 488px*$sun;
            height: 1px*$sun;
            background-color: #E6E6E6;
            // border: .0063rem solid #E6E6E6;
        }
        span{
            padding: 0 20px*$sun;
            font-size: 22px*$sun;
            color: #666666;
            font-weight: 500;
        }
    }
    .detail{
        display: flex;
        flex-wrap: wrap;
        padding: 50px*$sun 360px*$sun ;
        height: 383px*$sun;
        font-size: 24px*$sun;
        color: #666666;
        line-height: 50px*$sun;
    }
}
.title{
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #000;
    overflow: hidden;
    .breadcrumb{
        padding: 0 360px*$sun;
        font-size: 24px*$sun;
        margin-top: 50px*$sun;
        font-weight: 500;
        .breadcrumbItem{
          font-weight: 500;
        }

    }
}
// 请求富文本
.newsItemShow{
    width: 1200px*$sun;
    min-height: 600px*$sun;
    margin: auto;
}
.newsItemShowTop{
    display: flex;
    justify-content: center;
    min-width: 1200px*$sun;
    video {
      width: 900px*$sun;
      height: 600px*$sun;
    }
}
</style>
